

























































































































import { Vue, Component } from "nuxt-property-decorator";
import BottomInterestForm from "~/components/common/BottomInterestForm.vue";
import MaxWidthSection from "~/components/common/MaxWidthSection.vue";
import CompanyCarousel from "~/components/startPageNew/CompanyCarousel.vue";
import GrPublicFooter from "~/components/startPageNew/GrPublicFooter.vue";

// import gsap from "gsap";

@Component({
  components: {
    MaxWidthSection,
    CompanyCarousel,
    BottomInterestForm,
    GrPublicFooter,
  },
})
export default class TermsOfUsePage extends Vue {
  head() {
    return {
      title: this.$t("Om oss").toString(),
    };
  }
}
